export default __webpack_public_path__ + "static/media/unselectcard.25a78772.mp3";